import React, { useEffect, useRef, useState } from 'react'
import { Impact, InnerWrapper, LeftLineSvg, Lhs, Logo, OuterWrapper, Rhs, RightLineSvg, Row, SelectWrapper } from './style';
import { getImageUrl } from '../../../../util';
import { MuiSelect } from '../../../../components';
import { Typography } from '@mui/material';
import { IconLeftLines, IconRightLines } from '../../../../assets/images/icons';

const Aura = ({ auraEntityData, InsightsElementType, auraClicked, compareAuraData, compareAura = false, minWidth, height, emptyAura, matchText, isComparison, auraIndex, brandLogoList }) => {
  const [auraData , setAuraData] = useState([]);
  const [selectedValue, setSelectedValue] = useState('')
  const [auraList , setAuraList] = useState({});
  const [hightLightText , setHighLightText] = useState(matchText);
  const [brandLogo, setBrandLogo] = useState('');
  const imgRef = useRef(null);

  useEffect(() => {
    setHighLightText(matchText)
  } , [matchText])

  useEffect(() => {
    const img = imgRef.current;
    if (!img) return;

    const handleLoad = () => {
      if (img.naturalHeight === img.naturalWidth) {
        img.style.maxWidth = '100px';
      } else {
        img.style.maxWidth = ''; // reset if needed
      }
    };

    img.addEventListener('load', handleLoad);

    // handle cached images
    if (img.complete) {
      handleLoad();
    }

    return () => {
      img.removeEventListener('load', handleLoad);
    };
  }, []);

  useEffect(() => {
    if (!isComparison) {
      setBrandLogo(auraEntityData.EntityLogo);
    }
  } , [auraEntityData])

  useEffect(() => {
    if (emptyAura) {
      const list = [{
        label: emptyAura[0]?.type?.includes('Progression') ? 'Select Period' : 'Select Brand' ,
        value : '',
      }];
      emptyAura.forEach((e , i) => {
        list.push({
          label: e.entity?.EntityName,
          value: e.entity?.EntityName,
          disabledValue : i === 0
        })
      })
      setAuraList(list);
    }
  }, [emptyAura]);


  const onChange = (key, value) => {

    setAuraData([])
    for (let i = 0 ; i <= emptyAura?.length ; i++) {
      if (value === '') {
        setBrandLogo('');

        break;
      }

      if (emptyAura[i]?.entity?.EntityName === value) {
        setAuraData(emptyAura[i]);

        if (isComparison && brandLogoList.length > 0) {
          for (let j = 0; j <= brandLogoList?.length; j++) {

            if (brandLogoList[j][emptyAura[i].ComparisonInsightsElementId]) {
              setBrandLogo(brandLogoList[j][emptyAura[i].ComparisonInsightsElementId].entityId);
              break;
            }
          }
        }

        break;
      }
    }
    setSelectedValue(value)
  }

  const rowsFontSize = (fontSize) => compareAura ? fontSize - 1 : fontSize;

  const rowWidth = (compareWidth, normalWidth) => compareAura ? `calc(50% - ${compareWidth}px)` : `calc(50% - ${normalWidth}px)`;

  const calculateTop = (compareTop, normalTop) => compareAura ? compareTop + 'px' : normalTop + 'px';

  const rhsMargin = (compareMargin, normalMargin) => compareAura ? compareMargin + 'px' : normalMargin + 'px';

  useEffect(() => {
    if (!isComparison && auraIndex && emptyAura) {
      setAuraData(emptyAura[auraIndex]);
      setSelectedValue(emptyAura[auraIndex]?.entity?.EntityName);
    } else {
      setAuraData(compareAuraData || {});
    }
  }, [compareAuraData, emptyAura]);
  
  return (
    <OuterWrapper height={height} minWidth={minWidth} compareAura={compareAura}>
      <InnerWrapper className={`auraTitle ${compareAura ? 'popupAura' : ''} ${InsightsElementType.includes('AuraWithoutSentiments') ? 'AuraWithoutSentiments' : ''}`}>
        {!!brandLogo?.length && (
          <Logo compareAura={compareAura} className={`logoWrapper ${compareAura ? 'compareAura' : ''}`}>
            <img
              ref={imgRef}
              src={`${getImageUrl('auraLogo', brandLogo, 'png')}`}
              alt={auraEntityData.EntityName}
            />
          </Logo>
        )}

        {!auraData && !auraData?.aura?.length && compareAura && (
          <>
          <LeftLineSvg><IconLeftLines /></LeftLineSvg>
          <RightLineSvg><IconRightLines /></RightLineSvg>
          </>
        )}

        {compareAura && !emptyAura && compareAuraData?.type.includes('Progression') &&
          <SelectWrapper className='progression-name'>
            <Typography fontSize={'13px'} color={'rgba(0, 0, 0, 1)'} >{compareAuraData?.entity?.EntityName}</Typography>
          </SelectWrapper>
        }


        {emptyAura && auraList?.length > 0 && 
        <SelectWrapper>

        <MuiSelect
             styletype='themeV2'
             name='entityName'
             onChange={(e, selectedData) => onChange(e.target.name, selectedData.value , e.target)}
             data={auraList}
             //  menuprops={{ style: { maxHeight: '200px', maxWidth: '180px' } }}
             variant='standard'
             // placeholder='All Brand/Category'
             compact
             selectlabel='label'
             selectvalue='value'
             displayEmpty
             value={selectedValue}
             renderValue={(selected) => {
               return selected === '' ? <span>{emptyAura[0]?.type?.includes('Progression') ? 'Select Period' : 'Select Brand'}</span> : selected
              }}
              />
          </SelectWrapper>
        }

        <Impact className={`high-impact ${compareAura ? 'compareAura' : ''}`}>HIGH IMPACT</Impact>
        <Impact className={`low-impact ${compareAura ? 'compareAura' : ''}`}>LOW IMPACT</Impact>

        {!!auraData?.aura?.length && (
          <>

            <Row className='rows box1' sx={{ fontSize: `${rowsFontSize(28)}px`, top: `${calculateTop(-3, -16)}` }}>
              <Lhs className='lhs-row' sx={{ width: `${rowWidth(20, 47)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[0] , compareAura)}
                  data-index='auraData_0'
                  className={`${auraData?.aura[0]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[0]?.Word ? 'hightLight-text' : ''}`}
                >
                  {auraData?.aura[0]?.Word}
                </span>
              </Lhs>
              <Rhs sx={{ width: `${rowWidth(2, 37)}`, marginTop: '2px' }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[1] , compareAura)}
                  data-index='auraData_1'
                  className={`${auraData?.aura[1]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[1]?.Word ? 'hightLight-text' : ''}`}
                >
                  {auraData?.aura[1]?.Word}
                </span>
              </Rhs>
            </Row>

            <Row className='rows box2' sx={{ fontSize: `${rowsFontSize(27)}px`, top: `${calculateTop(-5, -18)}` }}>
              <Lhs className='lhs-row' sx={{ width: `${rowWidth(69, 100)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[2] , compareAura)}
                  data-index='auraData_2'
                  className={`${auraData?.aura[2]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[2]?.Word ? 'hightLight-text' : ''}`}
                >
                  {auraData?.aura[2]?.Word}
                </span>
              </Lhs>
              <Rhs sx={{ width: `${rowWidth(47, 96)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[3] , compareAura)}
                  data-index='auraData_3'
                  className={`${auraData?.aura[3]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[3]?.Word ? 'hightLight-text' : ''}`}
                >
                  {auraData?.aura[3]?.Word}
                </span>
              </Rhs>
            </Row>

            <Row className='rows box3' sx={{ fontSize: `${rowsFontSize(26)}px`, top: `${calculateTop(-9, -18)}` }}>
              <Lhs className='lhs-row' sx={{ width: `${rowWidth(96, 138)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[4] , compareAura)}
                  data-index='auraData_4'
                  className={`${auraData?.aura[4]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[4]?.Word ? 'hightLight-text' : ''}`}
                >
                  {auraData?.aura[4]?.Word}
                </span>
              </Lhs>
              <Rhs sx={{ width: `${rowWidth(79, 119)}`, marginTop: `${rhsMargin(0, 0)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[5] , compareAura)}
                  data-index='auraData_5'
                  className={`${auraData?.aura[5]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[5]?.Word ? 'hightLight-text' : ''}`}
                >
                  {auraData?.aura[5]?.Word}
                </span>
              </Rhs>
            </Row>

            <Row
              className='rows box4'
              sx={{ fontSize: `${rowsFontSize(25)}px`, top: `${calculateTop(-9, -19)}` }}
            >
              <Lhs className='lhs-row' sx={{ width: `${rowWidth(115, 160)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[6] , compareAura)}
                  data-index='auraData_6'
                  className={`${auraData?.aura[6]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[6]?.Word ? 'hightLight-text' : ''}`}
                >
                  {auraData?.aura[6]?.Word}
                </span>
              </Lhs>
              <Rhs sx={{ width: `${rowWidth(102, 143)}`, marginTop: `${rhsMargin(0, 2)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[7] , compareAura)}
                  data-index='auraData_7'
                  className={`${auraData?.aura[7]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[7]?.Word ? 'hightLight-text' : ''}`}
                >
                  {auraData?.aura[7]?.Word}
                </span>
              </Rhs>
            </Row>

            <Row className='rows box1' sx={{ fontSize: `${rowsFontSize(24)}px`, top: `${calculateTop(-10, -19)}` }}>
              <Lhs className='lhs-row' sx={{ width: `${rowWidth(122, 176)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[8] , compareAura)}
                  data-index='auraData_8'
                  className={`${auraData?.aura[8]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[8]?.Word ? 'hightLight-text' : ''}`}
                >
                  {auraData?.aura[8]?.Word}
                </span>
              </Lhs>
              <Rhs sx={{ width: `${rowWidth(112, 160)}`, marginTop: `${rhsMargin(0, 0)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[9] , compareAura)}
                  data-index='auraData_9'
                  className={`${auraData?.aura[9]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[9]?.Word ? 'hightLight-text' : ''}`}
                >
                  {auraData?.aura[9]?.Word}
                </span>
              </Rhs>
            </Row>

            <Row className='rows box2' sx={{ fontSize: `${rowsFontSize(23)}px`, top: `${calculateTop(-9, -17)}` }}>
              <Lhs className='lhs-row' sx={{ width: `${rowWidth(129, 187)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[10] , compareAura)}
                  data-index='auraData_10'
                  className={`${auraData?.aura[10]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[10]?.Word ? 'hightLight-text' : ''}`}
                >
                  {auraData?.aura[10]?.Word}
                </span>
              </Lhs>
              <Rhs sx={{ width: `${rowWidth(120, 173)}`, marginTop: `${rhsMargin(-1, 0)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[11] , compareAura)}
                  data-index='auraData_11'
                  className={`${auraData?.aura[11]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[11]?.Word ? 'hightLight-text' : ''}`}
                >
                  {auraData?.aura[11]?.Word}
                </span>
              </Rhs>
            </Row>

            <Row className='rows box3' sx={{ fontSize: `${rowsFontSize(22)}px`, top: `${calculateTop(-9, -18)}` }}>
              <Lhs className='lhs-row' sx={{ width: `${rowWidth(133, 195)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[12] , compareAura)}
                  data-index='auraData_12'
                  className={`${auraData?.aura[12]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[12]?.Word ? 'hightLight-text' : ''}`}
                >
                  {auraData?.aura[12]?.Word}
                </span>
              </Lhs>
              <Rhs sx={{ width: `${rowWidth(123, 180)}`, marginTop: `${rhsMargin(1, 0)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[13] , compareAura)}
                  data-index='auraData_13'
                  className={`${auraData?.aura[13]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[13]?.Word ? 'hightLight-text' : ''}`}
                >
                  {auraData?.aura[13]?.Word}
                </span>
              </Rhs>
            </Row>

            <Row className='rows box4' sx={{ fontSize: `${rowsFontSize(21)}px`, top: `${calculateTop(-10, -17)}` }}>
              <Lhs className='lhs-row' sx={{ width: `${rowWidth(133, 199)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[14] , compareAura)}
                  data-index='auraData_14'
                  className={`${auraData?.aura[14]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[14]?.Word ? 'hightLight-text' : ''}`}
                >
                  {auraData?.aura[14]?.Word}
                </span>
              </Lhs>
              <Rhs sx={{ width: `${rowWidth(123, 185)}`, marginTop: `${rhsMargin(1, 1)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[15] , compareAura)}
                  data-index='auraData_15'
                  className={`${auraData?.aura[15]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[15]?.Word ? 'hightLight-text' : ''}`}
                >
                  {auraData?.aura[15]?.Word}
                </span>
              </Rhs>
            </Row>

            <Row className='rows box1' sx={{ fontSize: `${rowsFontSize(20)}px`, top: `${calculateTop(-10, -20)}` }}>
              <Lhs className='lhs-row' sx={{ width: `${rowWidth(133, 198)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[16] , compareAura)}
                  data-index='auraData_16'
                  className={`${auraData?.aura[16]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[16]?.Word ? 'hightLight-text' : ''}`}
                >
                  {auraData?.aura[16]?.Word}
                </span>
              </Lhs>
              <Rhs sx={{ width: `${rowWidth(123, 185)}`, marginTop: `${rhsMargin(0, 1)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[17] , compareAura)}
                  data-index='auraData_17'
                  className={`${auraData?.aura[17]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[17]?.Word ? 'hightLight-text' : ''}`}
                >
                  {auraData?.aura[17]?.Word}
                </span>
              </Rhs>
            </Row>

            <Row className='rows' sx={{ fontSize: `${rowsFontSize(19)}px`, top: `${calculateTop(-12, -19)}` }}>
              <Lhs className='lhs-row' sx={{ width: `${rowWidth(132, 198)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[18] , compareAura)}
                  data-index='auraData_18'
                  className={`${auraData?.aura[18]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[18]?.Word ? 'hightLight-text' : ''}` + ' box2'}
                >
                  {auraData?.aura[18]?.Word}
                </span>
              </Lhs>
              <Rhs sx={{ width: `${rowWidth(121, 183)}`, marginTop: `${rhsMargin(2, 2)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[19] , compareAura)}
                  data-index='auraData_19'
                  className={`${auraData?.aura[19]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[19]?.Word ? 'hightLight-text' : ''}` + ' box3'}
                >
                  {auraData?.aura[19]?.Word}
                </span>
              </Rhs>
            </Row>

            <Row className='rows' sx={{ fontSize: `${rowsFontSize(18)}px`, top: `${calculateTop(-11, -20)}` }}>
              <Lhs className='lhs-row' sx={{ width: `${rowWidth(129, 196)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[20] , compareAura)}
                  data-index='auraData_20'
                  className={`${auraData?.aura[20]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[20]?.Word ? 'hightLight-text' : ''}` + ' box2'}
                >
                  {auraData?.aura[20]?.Word}
                </span>
              </Lhs>
              <Rhs sx={{ width: `${rowWidth(117, 180)}`, marginTop: `${rhsMargin(0, 2)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[21] , compareAura)}
                  data-index='auraData_21'
                  className={`${auraData?.aura[21]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[21]?.Word ? 'hightLight-text' : ''}` + ' box4'}
                >
                  {auraData?.aura[21]?.Word}
                </span>
              </Rhs>
            </Row>

            <Row className='rows' sx={{ fontSize: `${rowsFontSize(17)}px`, top: `${calculateTop(-10, -25)}` }}>
              <Lhs className='lhs-row' sx={{ width: `${rowWidth(121, 192)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[22] , compareAura)}
                  data-index='auraData_22'
                  className={`${auraData?.aura[22]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[22]?.Word ? 'hightLight-text' : ''}` + ' box1'}
                >
                  {auraData?.aura[22]?.Word}
                </span>

              </Lhs>
              <Rhs sx={{ width: `${rowWidth(113, 175)}`, marginTop: `${rhsMargin(0, 4)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[23] , compareAura)}
                  data-index='auraData_23'
                  className={`${auraData?.aura[23]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[23]?.Word ? 'hightLight-text' : ''}` + ' box3'}
                >
                  {auraData?.aura[23]?.Word}
                </span>
              </Rhs>
            </Row>

            <Row className='rows' sx={{ fontSize: `${rowsFontSize(16)}px`, top: `${calculateTop(-9, -28)}` }}>
              <Lhs className='lhs-row' sx={{ width: `${rowWidth(115, 184)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[24] , compareAura)}
                  data-index='auraData_24'
                  className={`${auraData?.aura[24]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[24]?.Word ? 'hightLight-text' : ''}` + ' box4'}
                >
                  {auraData?.aura[24]?.Word}
                </span>
              </Lhs>
              <Rhs sx={{ width: `${rowWidth(105, 169)}`, marginTop: `${rhsMargin(-2, 2)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[25] , compareAura)}
                  data-index='auraData_25'
                  className={`${auraData?.aura[25]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[25]?.Word ? 'hightLight-text' : ''}` + ' box2'}
                >
                  {auraData?.aura[25]?.Word}
                </span>
              </Rhs>
            </Row>

            <Row className='rows' sx={{ fontSize: `${rowsFontSize(15)}px`, top: `${calculateTop(-8, -27)}` }}>
              <Lhs className='lhs-row' sx={{ width: `${rowWidth(110, 176)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[26] , compareAura)}
                  data-index='auraData_26'
                  className={`${auraData?.aura[26]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[26]?.Word ? 'hightLight-text' : ''}` + ' box1'}
                >
                  {auraData?.aura[26]?.Word}
                </span>
              </Lhs>
              <Rhs sx={{ width: `${rowWidth(100, 161)}`, marginTop: `${rhsMargin(-3, 2)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[27] , compareAura)}
                  data-index='auraData_27'
                  className={`${auraData?.aura[27]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[27]?.Word ? 'hightLight-text' : ''}` + ' box2'}
                >
                  {auraData?.aura[27]?.Word}
                </span>
              </Rhs>
            </Row>

            <Row className='rows' sx={{ fontSize: `14px`, top: `${calculateTop(-5, -26)}` }}>
              <Lhs className='lhs-row' sx={{ width: `${rowWidth(100, 168)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[28] , compareAura)}
                  data-index='auraData_28'
                  className={`${auraData?.aura[28]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[28]?.Word ? 'hightLight-text' : ''}` + ' box3'}
                >
                  {auraData?.aura[28]?.Word}
                </span>
              </Lhs>
              <Rhs sx={{ width: `${rowWidth(90, 153)}`, marginTop: `${rhsMargin(-5, 2)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[29] , compareAura)}
                  data-index='auraData_29'
                  className={`${auraData?.aura[29]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[29]?.Word ? 'hightLight-text' : ''}` + ' box4'}
                >
                  {auraData?.aura[29]?.Word}
                </span>

              </Rhs>
            </Row>

            <Row className='rows' sx={{ fontSize: `14px`, top: `${calculateTop(-5, -28)}` }}>
              <Lhs className='lhs-row' sx={{ width: `${rowWidth(87, 158)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[30] , compareAura)}
                  data-index='auraData_30'
                  className={`${auraData?.aura[30]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[30]?.Word ? 'hightLight-text' : ''}` + ' box3'}
                >
                  {auraData?.aura[30]?.Word}
                </span>
              </Lhs>
              <Rhs sx={{ width: `${rowWidth(78, 142)}`, marginTop: `${rhsMargin(-5, 2)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[31] , compareAura)}
                  data-index='auraData_31'
                  className={`${auraData?.aura[31]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[31]?.Word ? 'hightLight-text' : ''}` + ' box4'}
                >
                  {auraData?.aura[31]?.Word}
                </span>
              </Rhs>
            </Row>

            <Row className='rows' sx={{ fontSize: `14px`, top: `${calculateTop(-4, -27)}` }}>
              <Lhs className='lhs-row' sx={{ width: `${rowWidth(74, 146)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[32] , compareAura)}
                  data-index='auraData_32'
                  className={`${auraData?.aura[32]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[32]?.Word ? 'hightLight-text' : ''}` + ' box1'}
                >
                  {auraData?.aura[32]?.Word}
                </span>
              </Lhs>
              <Rhs sx={{ width: `${rowWidth(63, 127)}`, marginTop: `${rhsMargin(-2, 2)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[33] , compareAura)}
                  data-index='auraData_33'
                  className={`${auraData?.aura[33]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[33]?.Word ? 'hightLight-text' : ''}` + ' box2'}
                >
                  {auraData?.aura[33]?.Word}
                </span>
              </Rhs>
            </Row>

            <Row className='rows' sx={{ fontSize: `14px`, top: `${calculateTop(-2, -27)}` }}>
              <Lhs className='lhs-row' sx={{ width: `${rowWidth(61, 130)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[34] , compareAura)}
                  data-index='auraData_34'
                  className={`${auraData?.aura[34]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[34]?.Word ? 'hightLight-text' : ''}` + ' box1'}
                >
                  {auraData?.aura[34]?.Word}
                </span>
              </Lhs>
              <Rhs sx={{ width: `${rowWidth(48, 112)}`, marginTop: `${rhsMargin(-1, 1)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[35] , compareAura)}
                  data-index='auraData_35'
                  className={`${auraData?.aura[35]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[35]?.Word ? 'hightLight-text' : ''}` + ' box2'}
                >
                  {auraData?.aura[35]?.Word}
                </span>
              </Rhs>
            </Row>

            <Row className='rows' sx={{ fontSize: `14px`, top: `${calculateTop(-2, -27)}` }}>
              <Lhs className='lhs-row' sx={{ width: `${rowWidth(39, 110)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[36] , compareAura)}
                  data-index='auraData_36'
                  className={`${auraData?.aura[36]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[36]?.Word ? 'hightLight-text' : ''}` + ' box3'}
                >
                  {auraData?.aura[36]?.Word}
                </span>
              </Lhs>
              <Rhs sx={{ width: `${rowWidth(34, 95)}`, marginTop: `${rhsMargin(-1, 0)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[37] , compareAura)}
                  data-index='auraData_37'
                  className={`${auraData?.aura[37]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[37]?.Word ? 'hightLight-text' : ''}` + ' box4'}
                >
                  {auraData?.aura[37]?.Word}
                </span>
              </Rhs>
            </Row>
           
            <Row className='rows' sx={{ fontSize: `14px`, top: `${calculateTop(-2, -27)}` }}>
              <Lhs className='lhs-row' sx={{ width: `${rowWidth(30, 100)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[38] , compareAura)}
                  data-index='auraData_38'
                  className={`${auraData?.aura[38]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[38]?.Word ? 'hightLight-text' : ''}` + ' box3'}
                >
                  {auraData?.aura[38]?.Word}
                </span>
              </Lhs>
              <Rhs sx={{ width: `${rowWidth(25, 85)}`, marginTop: `${rhsMargin(-1, 0)}` }}>
                <span
                  onClick={(e) => auraClicked(e, auraData?.aura[39] , compareAura)}
                  data-index='auraData_39'
                  className={`${auraData?.aura[39]?.Sentiment} ${hightLightText && hightLightText === auraData?.aura[39]?.Word ? 'hightLight-text' : ''}` + ' box4'}
                >
                  {auraData?.aura[39]?.Word}
                </span>
              </Rhs>
            </Row>
          </>

        )}
      </InnerWrapper>
    </OuterWrapper>
  )
}

export default Aura;
